/**
 * @format
 * @flow
 */
import * as Template from '../constants/reducers/Template';

const initialState = {
    Template: " ",
    TemplateItems:[],
    TemplateDelete: false,
    TemplateItem:{},
    isEdited: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case Template.POST_TEMPLATE:
            return { Template: action.data };
        case Template.RESET_TEMPLATE:
            return { Template: "" };
        case Template.GET_TEMPLATE:
            return { ...state, TemplateItems: action.data };
        case Template.DELETE_TEMPLATE:
            return { TemplateDelete: action.data };
        case Template.RESET_DELETE_TEMPLATE:
            return { FaqDelete: false };
        case Template.GET_TEMPLATE_ID:
            return { TemplateItem: action.data };
        case Template.EDIT_TEMPLATE:
            return { isEdited: action.data };
        default:
            return state;
    }
}
